(function () {
  angular.module('7Shop.Common').directive('dateSelected', function dateSelected($rootScope) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        elem.on('click', function () {
          $rootScope.$broadcast('7S:Datepicker.DateSelected', attrs.dateSelected);
        });
      }
    };
  });
})();
